import React from 'react'

import { Col, Divider, Row } from 'antd'
import classNames from 'classnames'

import { ProductIds } from 'core/application/commons/config'

import { useBreakPoints } from 'common/hooks'

import InternalToolsLogo from '../assets/images/InternalTools.svg'
import QsehraLogo from '../assets/images/QSEHRA.svg'
import PerksLogo from '../assets/images/Stipends.svg'
import GCHRALogo from '../assets/images/gchra.svg'
import GroupHRALogo from '../assets/images/group-hra-ver-2.svg'
import IchraLogo from '../assets/images/ichra-logo.svg'
import PeopleKeepLogo from '../assets/images/people-keep-benefits-personalized.svg'

interface ProductLogoProps {
  styled?: boolean
  eeSignUp?: number
  productId: string
  hidePKLogo?: boolean
  shortGchra?: boolean
}

const ProductLogo = ({ hidePKLogo = false, shortGchra = false, eeSignUp, productId }: ProductLogoProps) => {
  const { isXl } = useBreakPoints()

  return (
    <div className={classNames({ grid: true, flex: isXl })}>
      {!hidePKLogo && (
        <div>
          <img src={PeopleKeepLogo} alt="peoplekeep-logo" />

          <Divider type="vertical" style={{ height: '100%' }} />
        </div>
      )}
      <div className={classNames({ 'my-auto': isXl, 'flex account-products-image-section mt-8': !isXl })}>
        {parseInt(productId) === ProductIds.QsehraId || eeSignUp === ProductIds.QsehraId ? (
          <img src={QsehraLogo} alt="peoplekeep-logo" />
        ) : parseInt(productId) === ProductIds.Perks || eeSignUp === ProductIds.Perks ? (
          <img src={PerksLogo} alt="peoplekeep-logo" />
        ) : parseInt(productId) === ProductIds.IchraId || eeSignUp === ProductIds.IchraId ? (
          <img src={IchraLogo} alt="peoplekeep-logo" />
        ) : parseInt(productId) === -1 ? (
          <img src={InternalToolsLogo} alt="peoplekeep-logo" />
        ) : (
          <img src={shortGchra ? GCHRALogo : GroupHRALogo} alt="peoplekeep-logo" />
        )}
      </div>
    </div>
  )
}

export default ProductLogo
